export default {
  title: 'E-Certificate',
  form: {
    employeeCode: {
      label: 'Employee code for this certificate',
      placeholder: 'Enter an employee code in the current company',
      hint: 'Leave blank to request a certificate for yourself'
    },
    certificateType: {
      label: 'Certificate Type',
      placeholder: 'Certificate Type'
    }
  },
  button: {
    request: 'Request Certificate',
    submit: 'Request Certificate',
    print: 'Print Certificate'
  }
}
